'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectInfiniteHits = require('../connectors/connectInfiniteHits');

var _connectInfiniteHits2 = _interopRequireDefault(_connectInfiniteHits);

var _InfiniteHits = require('../components/InfiniteHits');

var _InfiniteHits2 = _interopRequireDefault(_InfiniteHits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Displays an infinite list of hits along with a **load more** button.
 *
 * To configure the number of hits being shown, use the [HitsPerPage widget](widgets/HitsPerPage.html),
 * [connectHitsPerPage connector](connectors/connectHitsPerPage.html) or the [Configure widget](widgets/Configure.html).
 *
 * @name InfiniteHits
 * @kind widget
 * @propType {Component} [hitComponent] - Component used for rendering each hit from
 *   the results. If it is not provided the rendering defaults to displaying the
 *   hit in its JSON form. The component will be called with a `hit` prop.
 * @themeKey ais-InfiniteHits - the root div of the widget
 * @themeKey ais-InfiniteHits-list - the list of hits
 * @themeKey ais-InfiniteHits-item - the hit list item
 * @themeKey ais-InfiniteHits-loadMore - the button used to display more results
 * @themeKey ais-InfiniteHits-loadMore--disabled - the disabled button used to display more results
 * @translationKey loadMore - the label of load more button
 * @example
 * import React from 'react';
 * import { InstantSearch, InfiniteHits } from 'react-instantsearch/dom';
 *
 * const App = () => (
 *   <InstantSearch
 *     appId="latency"
 *     apiKey="6be0576ff61c053d5f9a3225e2a90f76"
 *     indexName="ikea"
 *   >
 *     <InfiniteHits />
 *   </InstantSearch>
 * );
 */

exports.default = (0, _connectInfiniteHits2.default)(_InfiniteHits2.default);


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/widgets/InfiniteHits.js
// module id = 1080
// module chunks = 142807904292071